import format from '@/lib/formatUtils/format'
import { defineObject } from '@/lib/define/use-define'
import {
  calculationOfUsageTime,
  sortKana,
  schoolYearConvert,
  confirmParentCheckData,
  atNewCldCreationData,
  atCldCreationData,
  countChildData,
  countVisitChildData,
  creationDate,
  sortInOrderOfSchoolYearOfVisit,
} from '@/lib/format/use-data-format'
import { handleSortQualificationArray } from '@/lib/staff/utils'
import {
  handleChangeKeyCamelSet,
  handleSortStaffData,
} from '@/lib/list/staff-list-sort'
import {
  ElementType,
  StateType,
} from '@/components/pages/attendance/list/@types/index'
import {
  sortInOrderOfAgeOfJihatsu,
  sortInOrderOfSchoolYearOfHoday,
} from '@/lib/format/use-data-format'

const openWidth = '156px'
const closeWidth = '394px'

const tabletCloseWidth = '225px'

const setBackgroundNonClass = (array: { [key: string]: string }[]) => {
  array.forEach((e: { [key: string]: string }) => {
    e.backgroundClass = 'none'
  })
}

export const creationTargetDate = (
  year: number,
  month: number,
  day: number
) => {
  return new Date(year, month, day)
}
export const getKindOfRequest = (object: any) => {
  const dataObject = object as { [key: string]: any }

  const reasonArray = [] as { [key: string]: string }[]
  let type = ''
  if (!dataObject) return
  if ('flg' in dataObject) {
    if (dataObject['flg'] === 3) {
      type = 'add'
    } else if (dataObject['flg'] === 4 || dataObject['flg'] === 5) {
      type = 'absence'
    } else if (dataObject['flg'] === 1) {
      if ('reason_for_absence' in dataObject) {
        const reasonForAbsenceArray = dataObject['reason_for_absence'] as any
        if (
          typeof reasonForAbsenceArray === 'object' &&
          reasonForAbsenceArray !== null
        ) {
          const reason = reasonForAbsenceArray.slice(-1) as {
            [key: string]: string
          }[]

          if (reason.length !== 0) {
            reason[0].type = 'absence'
            reasonArray.push(reason[0])
          }
        }
      }
      if ('reason_for_add_to' in dataObject) {
        const reasonForAddToArray = dataObject['reason_for_add_to'] as any
        if (
          typeof reasonForAddToArray === 'object' &&
          reasonForAddToArray !== null
        ) {
          const reason = reasonForAddToArray.slice(-1) as {
            [key: string]: string
          }[]

          if (reason.length !== 0) {
            reason[0].type = 'add'
            reasonArray.push(reason[0])
          }
        }
      }
      if ('reason_for_reschedule' in dataObject) {
        const reasonForRescheduleArray = dataObject[
          'reason_for_reschedule'
        ] as any
        if (typeof reasonForRescheduleArray === 'object') {
          const reason = reasonForRescheduleArray.slice(-1) as {
            [key: string]: string
          }[]

          if (reason.length !== 0) {
            reason[0].type = 'reschedule'
            reasonArray.push(reason[0])
          }
        }
      }
    }
  }
  if (reasonArray.length === 1) {
    if (reasonArray[0].staff === '') {
      type = reasonArray[0].type
    }
    delete reasonArray[0].type
  }
  if (reasonArray.length > 1) {
    reasonArray.sort((a: any, b: any) => {
      let Atime = 0 as any
      let Btime = 0 as any
      if (a.time) {
        Atime = new Date(
          a.time.split(' ')[0].split('/')[0],
          a.time.split(' ')[0].split('/')[1],
          a.time.split(' ')[0].split('/')[2],
          a.time.split(' ')[1].split(':')[0],
          a.time.split(' ')[1].split(':')[1],
          a.time.split(' ')[1].split(':')[2]
        )
        Atime = Atime.getTime()
      }
      if (b.time) {
        Btime = new Date(
          b.time.split(' ')[0].split('/')[0],
          b.time.split(' ')[0].split('/')[1],
          b.time.split(' ')[0].split('/')[2],
          b.time.split(' ')[1].split(':')[0],
          b.time.split(' ')[1].split(':')[1],
          b.time.split(' ')[1].split(':')[2]
        )
        Btime = Btime.getTime()
      }
      return Btime - Atime
    })

    if (reasonArray[0].staff === '') {
      type = reasonArray[0].type
    }

    reasonArray.forEach(el => {
      delete el.type
    })
  }
  return type
}

// 過去か現在か判断
export const judgementIsPast = (year: number, month: number, day: number) => {
  let isPast = false
  const today = new Date()
  if (
    today.getFullYear() === year &&
    today.getMonth() + 1 === month &&
    today.getDate() === day
  ) {
    isPast = false
  } else if (new Date(year, month - 1, day).getTime() < today.getTime()) {
    isPast = true
  }
  return isPast
}

export const getKindOfRequestArray = (array: any) => {
  const dataArray = array.concat()

  const reasonArray = [] as any[]
  const typeArray = []
  if (dataArray.length === 0) return
  dataArray.forEach((el: any) => {
    if ('reason_for_absence' in el) {
      if (
        typeof el.reason_for_absence === 'object' &&
        el.reason_for_absence !== null
      ) {
        const reason = el.reason_for_absence.slice(-1)

        if (reason.length !== 0) {
          reason[0].type = 'absence'
          reasonArray.push(reason[0])
        }
      }
      if (
        typeof el.reason_for_absence === 'string' &&
        el.reason_for_absence !== ''
      ) {
        const reason = {
          parent: el.reason_for_absence,
          staff: '',
          time: '',
          type: 'absence',
        }
        reasonArray.push(reason)
      }
    }
    if ('reason_for_add_to' in el) {
      if (
        typeof el.reason_for_add_to === 'object' &&
        el.reason_for_add_to !== null
      ) {
        const reason = el.reason_for_add_to.slice(-1)

        if (reason.length !== 0) {
          reason[0].type = 'add'
          reasonArray.push(reason[0])
        }
      }
      if (
        typeof el.reason_for_add_to === 'string' &&
        el.reason_for_add_to !== ''
      ) {
        const reason = {
          parent: el.reason_for_add_to,
          staff: '',
          time: '',
          type: 'add',
        }
        reasonArray.push(reason)
      }
    }
    if ('reason_for_reschedule' in el) {
      if (typeof el.reason_for_reschedule === 'object') {
        const reason = el.reason_for_reschedule.slice(-1)

        if (reason.length !== 0) {
          reason[0].type = 'reschedule'
          reasonArray.push(reason[0])
        }
      }
    }
  })
  if (reasonArray.length === 1) {
    typeArray.push(reasonArray[0].type)
    delete reasonArray[0].type
  }
  if (reasonArray.length > 1) {
    reasonArray.sort((a, b) => {
      let Atime = 0 as any
      let Btime = 0 as any
      if (a.time) {
        Atime = new Date(
          a.time.split(' ')[0].split('/')[0],
          a.time.split(' ')[0].split('/')[1],
          a.time.split(' ')[0].split('/')[2],
          a.time.split(' ')[1].split(':')[0],
          a.time.split(' ')[1].split(':')[1],
          a.time.split(' ')[1].split(':')[2]
        )
        Atime = Atime.getTime()
      }
      if (b.time) {
        Btime = new Date(
          b.time.split(' ')[0].split('/')[0],
          b.time.split(' ')[0].split('/')[1],
          b.time.split(' ')[0].split('/')[2],
          b.time.split(' ')[1].split(':')[0],
          b.time.split(' ')[1].split(':')[1],
          b.time.split(' ')[1].split(':')[2]
        )
        Btime = Btime.getTime()
      }
      return Btime - Atime
    })

    reasonArray.forEach(el => {
      typeArray.push(el.type)
      delete el.type
    })
  }
  return typeArray
}

export const isAfterRevision = (targetYear: number, targetMonth: number) => {
  const NEW_BILLING_SERVICE_START_YEAR = 2024
  const NEW_BILLING_SERVICE_START_MONTH = 4

  const billingRevisionDate = new Date(
    NEW_BILLING_SERVICE_START_YEAR,
    NEW_BILLING_SERVICE_START_MONTH - 1,
    1
  )
  const targetDate = new Date(targetYear, targetMonth - 1, 1)
  if (billingRevisionDate > targetDate) {
    return false
  } else {
    return true
  }
}

export const getFormatNowTime = () => {
  const today = new Date()
  const nowTime = `${today.getFullYear()}/${(
    '0' +
    (today.getMonth() + 1)
  ).slice(-2)}/${('0' + today.getDate()).slice(-2)} ${(
    '0' + today.getHours()
  ).slice(-2)}:${('0' + today.getMinutes()).slice(-2)}:${(
    '0' + today.getSeconds()
  ).slice(-2)}`
  return nowTime
}

export const getIsAbsence2 = (atCld: any) => {
  let res = false

  const checkAtCld: { [key: string]: string | number } = {}

  Object.keys(atCld).forEach((key: string) => {
    const camelKey = format.camelCase(key)
    checkAtCld[camelKey] = atCld[key]
  })

  const diff = calculationOfUsageTime(
    checkAtCld.comeTimeHour,
    checkAtCld.comeTimeMinute,
    checkAtCld.returnTimeHour,
    checkAtCld.returnTimeMinute
  )

  if (
    checkAtCld.isCldBook === 1 &&
    checkAtCld.affiliation === '0' &&
    checkAtCld.alternativeSupport !== '1' &&
    diff <= 30 &&
    checkAtCld.flg === 1 &&
    !isAfterRevision(atCld.year, atCld.month)
  ) {
    res = true
  }

  return res
}

export const creationHolidayDate = (state: any) => {
  const currentDay = 1

  const today = new Date()
  const todayTime = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate(),
    0,
    0,
    0
  )

  state.holidayArray.forEach((data: any) => {
    const array = data.date.split('/')
    const holidayDate = new Date(array[0], array[1] - 1, array[2], 0, 0, 0)
    data.getTime = holidayDate.getTime()
  })

  const dateArray = []
  for (let i = 0; i <= state.appearDay; i++) {
    let holidayFlg = 0
    let isPast = false

    const date = `${state.selectYear}-${state.selectMonth}-${currentDay}`.replaceAll(
      '-',
      '/'
    )
    const selectDate = new Date(date)
    selectDate.setDate(selectDate.getDate() + i)
    const weekNumber = selectDate.getDay() as number
    let weekday
    if (weekNumber === 0) {
      weekday = 'sunday'
    } else if (weekNumber === 6) {
      weekday = 'saturday'
    } else {
      weekday = 'weekday'
    }

    const targetDate = new Date(
      state.selectYear,
      state.selectMonth - 1,
      currentDay + i,
      0,
      0,
      0
    )

    if (todayTime.getTime() > targetDate.getTime()) {
      isPast = true
    }

    const holidayInfo = state.holidayArray.find(
      (data: any) => targetDate.getTime() === data.getTime
    )

    if (holidayInfo) {
      holidayFlg = 1
    }

    dateArray.push({
      year: selectDate.getFullYear(),
      month: selectDate.getMonth() + 1,
      day: selectDate.getDate(),
      weekNumber: weekNumber,
      weekday: weekday,
      holidayFlg: holidayFlg,
      isPast: isPast,
    })
  }
  state.monthArray = dateArray
}

export const handleSeparationAffiliation = (state: any) => {
  state.allHohouChildArray = state.allChildArray.filter(
    (e: { [key: string]: string }) => {
      return e.visit_child_flg === '1'
    }
  )
  state.allChildArray = state.allChildArray.filter(
    (e: { [key: string]: string }) => {
      return e.affiliation === '0' || e.affiliation === '1'
    }
  )
}

export const handleOpenAppearChildData = (state: any) => {
  const el = document.getElementById('js-child_column') as any
  if (state.isChildDataAppear) {
    state.isChildDataAppear = false
    el.style.width = openWidth
    return
  }
  state.isChildDataAppear = true
  if (state.device === 'tablet') {
    el.style.width = tabletCloseWidth
  } else {
    el.style.width = closeWidth
  }
}

export const handleOpenAppearHohouChildData = (state: any) => {
  const el = document.getElementById('js-child_column-visit') as any
  if (state.isHohouChildDataAppear) {
    state.isHohouChildDataAppear = false
    el.style.width = openWidth
    return
  }
  state.isHohouChildDataAppear = true
  if (state.device === 'tablet') {
    el.style.width = tabletCloseWidth
  } else {
    el.style.width = closeWidth
  }
}

export const formatOrderChildFromJihatsuToHooday = (allChildArray: any) => {
  // 放デイ
  const hodayChildArray = allChildArray.filter(
    (e: { [key: string]: string }) => e.affiliation === '0'
  )

  const hodayActiveChildArray = hodayChildArray.filter(
    (e: { [key: string]: number }) => e.active === 1
  )
  const hodayNoneActiveChildArray = hodayChildArray.filter(
    (e: { [key: string]: number }) => e.active === 0
  )

  // 児発
  const hjihatsuChildArray = allChildArray.filter(
    (e: { [key: string]: string }) => e.affiliation === '1'
  )

  const hjihatsuActiveChildArray = hjihatsuChildArray.filter(
    (e: { [key: string]: number }) => e.active === 1
  )
  const hjihatsuNoneActiveChildArray = hjihatsuChildArray.filter(
    (e: { [key: string]: number }) => e.active === 0
  )

  setBackgroundNonClass(hodayNoneActiveChildArray)
  setBackgroundNonClass(hjihatsuNoneActiveChildArray)

  const afterSortHodayActiveChildArray = sortKana<{ [key: string]: string }>(
    hodayActiveChildArray
  )
  const afterSortHodayNoneActiveChildArray = sortKana<{
    [key: string]: string
  }>(hodayNoneActiveChildArray)

  const afterSorthJihatsuActiveChildArray = sortKana<{ [key: string]: string }>(
    hjihatsuActiveChildArray
  )
  const afterSorthJihatsuNoneActiveChildArray = sortKana<{
    [key: string]: string
  }>(hjihatsuNoneActiveChildArray)

  const afterSortHodayChildArray = afterSortHodayActiveChildArray.concat(
    afterSortHodayNoneActiveChildArray
  )
  const afterSortjihatsuChildArray = afterSorthJihatsuActiveChildArray.concat(
    afterSorthJihatsuNoneActiveChildArray
  )

  const sortChildData = afterSortjihatsuChildArray.concat(
    afterSortHodayChildArray
  )

  return sortChildData
}

export const formatOrderChildHohou = (childArray: { [key: string]: any }[]) => {
  const activeChildArray = childArray.filter(
    (e: { [key: string]: number }) => e.active === 1
  )
  const noneActiveChildArray = childArray.filter(
    (e: { [key: string]: number }) => e.active === 0
  )
  setBackgroundNonClass(noneActiveChildArray)

  const sortActiveChildArray = sortKana<{ [key: string]: string }>(
    activeChildArray
  )

  const sortNoneActiveChildArray = sortKana<{ [key: string]: string }>(
    noneActiveChildArray
  )

  const sortChildData = sortActiveChildArray.concat(sortNoneActiveChildArray)
  return sortChildData
}

export const sortChildData = (state: any) => {
  // 通所児童、保訪児童で分別
  handleSeparationAffiliation(state)

  // 名前順で並べ替え
  state.allChildArray = formatOrderChildFromJihatsuToHooday(state.allChildArray)
  state.allHohouChildArray = formatOrderChildHohou(state.allHohouChildArray)

  // 初期値を持っておく
  state.allResponseChildArray = schoolYearConvert(state.allChildArray)
  state.allHohouResponseChildArray = schoolYearConvert(state.allHohouChildArray)

  // 年齢・学年のコンバート
  state.allChildArray = schoolYearConvert(state.allChildArray)
  state.allHohouChildArray = schoolYearConvert(state.allHohouChildArray)

  if (!state.noActiveChildView) {
    state.allChildArray = state.allResponseChildArray.filter(
      (e: { [key: string]: number }) => e.active === 1
    )
  }

  if (!state.noActiveVisitChildView) {
    state.allHohouChildArray = state.allHohouResponseChildArray.filter(
      (e: { [key: string]: number }) => e.active === 1
    )
  }

  // 通所児童の予定チェック
  state.allChildArray = confirmParentCheckData(
    state.allChildArray,
    state.atChildAllArray
  )
}

export const createDefaultIdArray = (state: any) => {
  state.defaultIdArray = []
  state.allChildArray.forEach((el: any) => {
    state.defaultIdArray.push(el.id)
  })

  state.defaultIdArray = state.defaultIdArray.concat()

  state.defaultHohouIdArray = []
  state.allHohouChildArray.forEach((el: any) => {
    state.defaultHohouIdArray.push(el.id)
  })

  state.defaultHohouIdArray = state.defaultHohouIdArray.concat()
}

export const atNewHohouCldCreationData = (state: any) => {
  const afterSortAtChildArray = [] as any[]
  const selectDay = 1
  const today = new Date()
  const dateArray = creationDate(
    state.appearDay,
    state.selectYear,
    state.selectMonth,
    selectDay
  )
  state.allHohouChildArray.forEach((child: any, index: number) => {
    Object.keys(child).forEach((key: string) => {
      if (key === 'school_year') return
      const value = child[key]
      const camelCase = format.camelCase(key)
      state.allHohouChildArray[index][camelCase] = value
    })

    const atDataArray = [] as any[]
    dateArray.forEach((date: any) => {
      const currentWeek = defineObject.FORMULA_WEEK_ARRAY[date.weekNumber]
      const object = {
        cldId: child.id,
        lastName: child.last_name,
        firstName: child.first_name,
        flg: 9,
        year: date.year,
        month: date.month,
        day: date.day,
        yearClass: `year_${date.year}`,
        monthClass: `${date.day}`,
        dayClass: date.weekday,
        week: currentWeek,
        weekNumber: date.weekNumber,
        isNew: '',
        reasonForAbsence: [],
      }
      atDataArray.push(object)
    })

    // 過去で連絡帳なしの出欠は排除
    state.atHohouChildAllArray = state.atHohouChildAllArray.filter(
      (atCldData: any) => {
        const targetDate = creationTargetDate(
          atCldData.year,
          atCldData.month - 1,
          atCldData.day
        )
        const todayDate = creationTargetDate(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        )
        return (
          targetDate.getTime() >= todayDate.getTime() ||
          (targetDate.getTime() < todayDate.getTime() &&
            (atCldData.is_cld_book === 1 || atCldData.flg === 0))
        )
      }
    )

    const filterChildArray = state.atHohouChildAllArray.filter((el: any) => {
      return child.id === el.cld_id
    })
    atDataArray.forEach((date: any, index: number) => {
      filterChildArray.forEach(
        (atCldData: { [key: string]: number | boolean | string | any }) => {
          const object = {} as any
          Object.keys(atCldData).forEach((key: string) => {
            const camelKey = format.camelCase(key)
            if (key === 'reason_for_absence') {
              object[key] = atCldData[key]
            }
            object[camelKey] = atCldData[key]
          })
          if (
            object.year === date.year &&
            object.month === date.month &&
            object.day === date.day
          ) {
            object.week = date.week
            const targetDate = creationTargetDate(
              object.year,
              object.month - 1,
              object.day
            )
            const todayDate = creationTargetDate(
              today.getFullYear(),
              today.getMonth(),
              today.getDate()
            )
            if (targetDate.getTime() >= todayDate.getTime()) {
              object.cldId = atCldData['cld_id']
              if (object.flg === 2) {
                // 過去は除く
                object.isRequest = true
              }
            }
            atDataArray.splice(index, 1, object)
          }
        }
      )
    })
    let backgroundClass = ''
    if (child.active === 0) {
      backgroundClass = 'none'
    }
    afterSortAtChildArray.push({
      cldId: child.id,
      backgroundClass: backgroundClass,
      data: atDataArray,
    })
  })
  return afterSortAtChildArray
}

export const atHohouCldCreationData = (state: any) => {
  const selectDay = 1
  const afterSortAtChildArray = [] as any[]
  const totalAttendanceArray = [] as any
  const totalCancelArray = [] as any
  let dailyStaffArray = [] as any
  // let shiftManagementFlg = false

  const dateArray = creationDate(
    state.appearDay,
    state.selectYear,
    state.selectMonth,
    selectDay
  )
  dateArray.forEach((date: any) => {
    const totalDataArray = {
      year: date.year,
      month: date.month,
      day: date.day,
      attendance: 0,
      cancel: 0,
      staffArray: [],
    } as any

    state.staffArray = []
    state.monthArray.forEach((date: any, index: number) => {
      const array = [] as any
      state.staffArray[index] = array
    })

    state.allHohouChildArray.forEach((child: { [key: string]: string }) => {
      state.atHohouChildAllArray.forEach((el: any) => {
        if (child.id === el.cld_id || child.id === el.cldId) {
          if (
            el.year === date.year &&
            el.month === date.month &&
            el.day === date.day
          ) {
            if (el.flg === 1) {
              totalDataArray.attendance++
            } else if (el.flg === 0) {
              totalDataArray.cancel++
            }
          }
        }
      })

      // 訪問員出欠データの訪問員、児発管
      const filterChildArray = state.atHohouChildAllArray.filter((el: any) => {
        return child.id === el.cld_id || child.id === el.cldId
      })
      filterChildArray.forEach((atCld: { [key: string]: string | number }) => {
        if (atCld.manager !== '' && atCld.flg === 1) {
          state.staffArray[Number(atCld.day) - 1].push(
            ...state.staffInfoArray.filter(
              (staff: { [key: string]: string }) =>
                staff.staff_id === atCld.manager
            )
          )
        }
        if (
          atCld.leader !== '' &&
          atCld.manager !== atCld.leader &&
          atCld.flg === 1
        ) {
          state.staffArray[Number(atCld.day) - 1].push(
            ...state.staffInfoArray.filter(
              (staff: { [key: string]: string }) =>
                staff.staff_id === atCld.leader
            )
          )
        }
      })
    })

    totalAttendanceArray.push(totalDataArray.attendance)
    totalCancelArray.push(totalDataArray.cancel)

    // 重複削除
    state.staffArray.forEach((staffArray: any, index: number) => {
      staffArray = staffArray.filter(
        (element: any, index: number, self: any) =>
          self.findIndex((e: any) => e.staff_id === element.staff_id) === index
      )
      state.staffArray[index] = staffArray
    })
    state.staffArray.forEach((staffArray: { [key: string]: string }[]) => {
      let attendanceStaffArray = []
      if (staffArray.length !== 0) {
        staffArray.forEach((staffInfo: { [key: string]: string | any }) => {
          if (Array.isArray(staffInfo.qualification)) {
            const qualificationArray: {
              [key: string]: string
            }[] = []
            staffInfo.qualification.some((qualificationId: string) => {
              const qualificationData = state.qualificationArray.find(
                (qualification: { [key: string]: string }) =>
                  qualification.id === qualificationId
              )
              if (!qualificationData) return true
              qualificationArray.push(qualificationData)
            })
            staffInfo.qualificationArray = []
            staffInfo.qualificationArray.push(
              ...handleSortQualificationArray(qualificationArray)
            )
          }
        })
        attendanceStaffArray = staffArray
        attendanceStaffArray = handleChangeKeyCamelSet(staffArray)

        attendanceStaffArray = handleSortStaffData(attendanceStaffArray)
      }
      totalDataArray.staffArray.push(attendanceStaffArray)
    })
    dailyStaffArray = totalDataArray.staffArray
  })

  afterSortAtChildArray.push({
    attendance: totalAttendanceArray,
    cancel: totalCancelArray,
    dailyStaff: dailyStaffArray,
  })

  return afterSortAtChildArray
}

export const sortAttendanceData = (state: any) => {
  state.atCldDataArray = atNewCldCreationData(
    state.appearDay,
    state.selectYear,
    state.selectMonth,
    1,
    state.allChildArray,
    state.atChildAllArray
  )
  state.afterSortAtChildArray = atCldCreationData(
    state.appearDay,
    state.selectYear,
    state.selectMonth,
    1,
    state.allChildArray,
    state.atChildAllArray,
    state.atStaffAllArray,
    state
  )
  state.allChildArray = countChildData(
    state.allChildArray,
    state.atChildAllArray
  )

  // 訪問支援
  state.atCldHohouDataArray = atNewHohouCldCreationData(state)
  state.afterSortAtHohouChildArray = atHohouCldCreationData(state)
  countVisitChildData(state)
}

export const sortAttendanceDataOfVisit = (state: any) => {
  // 訪問支援
  state.afterSortAtHohouChildArray = atHohouCldCreationData(state)

  state.atCldHohouDataArray = atNewHohouCldCreationData(state)

  countVisitChildData(state)
}

export const adjustCellHeight = (
  state: any,
  isDesktop?: boolean,
  isOem?: string
) => {
  let totaloffsetHeight = 0

  for (let i = 0; i < state.allChildArray.length; i++) {
    const columns = document.getElementsByClassName(
      `column_title_${i}`
    ) as HTMLCollectionOf<HTMLElement>
    const cldNameEle = document.getElementsByClassName(
      `child_name_dd_${i}`
    ) as HTMLCollectionOf<HTMLElement>

    // 要素が不足している場合は処理をスキップ
    if (columns.length < 2 || cldNameEle.length < 1) continue

    if (isDesktop) {
      if (columns[0].offsetHeight !== columns[1].offsetHeight) {
        totaloffsetHeight += columns[1].offsetHeight
        columns[1].style.height = `${columns[0].offsetHeight}px`
        cldNameEle[0].style.height = `${columns[0].offsetHeight}px`
      }
    } else {
      if (isOem === '0') {
        if (columns[0].offsetHeight !== columns[1].offsetHeight) {
          totaloffsetHeight += columns[1].offsetHeight + 1
          columns[1].style.height = `${columns[0].offsetHeight + 1}px`
          cldNameEle[0].style.height = `${columns[0].offsetHeight + 1}px`
        }
      } else {
        // OEM連携の場合
        if (columns[0].offsetHeight !== columns[1].offsetHeight) {
          totaloffsetHeight += columns[1].offsetHeight + 1
          columns[1].style.height = `${columns[0].offsetHeight + 10}px`
          cldNameEle[0].style.height = `${columns[0].offsetHeight + 10}px`
        }
      }
    }
  }

  for (let i = 0; i < state.allHohouChildArray.length; i++) {
    const columns = document.getElementsByClassName(
      `column_title_hohou${i}`
    ) as HTMLCollectionOf<HTMLElement>
    const cldNameEle = document.getElementsByClassName(
      `child_name_dd_hohou${i}`
    ) as HTMLCollectionOf<HTMLElement>

    // 要素が不足している場合は処理をスキップ
    if (columns.length < 2 || cldNameEle.length < 1) continue

    if (isDesktop) {
      if (columns[0].offsetHeight !== columns[1].offsetHeight) {
        totaloffsetHeight += columns[1].offsetHeight
        columns[1].style.height = `${columns[0].offsetHeight}px`
        cldNameEle[0].style.height = `${columns[0].offsetHeight}px`
      }
    } else {
      if (columns[0].offsetHeight !== columns[1].offsetHeight) {
        totaloffsetHeight += columns[1].offsetHeight + 1
        columns[1].style.height = `${columns[0].offsetHeight + 1}px`
        cldNameEle[0].style.height = `${columns[0].offsetHeight + 1}px`
      }
    }
  }
}

export const handleTabSwitch = (state: any, index: number) => {
  state.tabs = index
}

export const handleHohouOpenModal = (
  state: any,
  response: any,
  childData: any
) => {
  const atChildData = response.data.data[6][0]
  Object.keys(atChildData).forEach((key: string) => {
    const camelKey = format.camelCase(key)
    atChildData[camelKey] = atChildData[key]
  })

  Object.keys(childData).forEach((key: string) => {
    const value = childData[key]
    const camelKey = format.camelCase(key)
    if (camelKey === 'id') {
      state.isAtDataDelete = true
    }
    if (camelKey === 'flg') {
      state.changeFlg = value
    }
    atChildData[camelKey] = value
  })

  atChildData['reasonForAbsence'] = []

  return atChildData
}

export const filterVisitLeaderArray = (
  staffArray: any,
  staffSkillsData: any
) => {
  const JIDOU_HATTATSU = '児童発達支援管理責任者'

  return staffArray.filter((staff: any) => {
    if (staff.qualification) {
      if (
        staff.qualification.includes(
          staffSkillsData.filter(
            (skill: any) => skill.qualification === JIDOU_HATTATSU
          )[0].id
        )
      ) {
        return staff
      }
    }
  })
}

export const validAtChildModal = (state: any, type: string) => {
  // 通所のバリデーション
  if (type === 'tsusyo') {
    if (state.modalChild.flg === 9 && !state.modalChild.id) {
      alert('利用種類、出欠種類を選択してください。')
      return false
    }

    if (state.modalChild.temporaryAttendance === '') {
      alert('利用種類を選択してください。')
      return false
    }

    if (
      state.modalChild.flg === 3 ||
      state.modalChild.flg === 4 ||
      state.modalChild.flg === 5
    ) {
      alert('出欠種類を選択してください')
      return false
    }
    if (state.modalChild.flg === 1) {
      const diff = calculationOfUsageTime(
        state.modalChild.comeTimeHour,
        state.modalChild.comeTimeMinute,
        state.modalChild.returnTimeHour,
        state.modalChild.returnTimeMinute
      )
      if (diff <= 0) {
        alert('来所予定時間と退所予定時間をご確認ください')
        return false
      }
    }
    // 申請への返信確認
    if (
      state.changeFlg === 3 ||
      state.changeFlg === 4 ||
      state.changeFlg === 5 ||
      (state.changeFlg === 1 && state.requestType === 'reschedule')
    ) {
      if (state.staffReply === '') {
        alert('申請の内容に対して保護者へのメッセージを入力してください。')
        return false
      }
      state.requestArray[0].staff = `${state.staffReply}`
    }
  } else {
    // 保訪のバリデーション
    if (state.modalChild.flg === 9 && !state.modalChild.id) {
      alert('実施、実施キャンセルのどちらかを選択してください。')
      return false
    }

    if (state.modalChild.flg === 2) {
      alert('実施、実施キャンセルのどちらかを選択してください。')
      return false
    }

    if (state.modalChild.flg === 1) {
      const diff = calculationOfUsageTime(
        state.modalChild.comeTimeHour,
        state.modalChild.comeTimeMinute,
        state.modalChild.returnTimeHour,
        state.modalChild.returnTimeMinute
      )
      if (diff <= 0) {
        alert('実施時間をご確認ください')
        return false
      }
    }

    if (state.changeFlg === 2) {
      if (state.staffReply === '') {
        alert('申請の内容に対して保護者へのメッセージを入力してください。')
        return false
      }
      state.requestArray[0].staff = `${state.staffReply}`
    }
  }
  return true
}

export const handleUpdateVisitAttendanceView = (state: any) => {
  state.atCldHohouDataArray.forEach((child: any) => {
    if (state.modalChild == null) return
    if (
      child.cld_id === state.modalChild.cldId ||
      child.cldId === state.modalChild.cldId
    )
      child.data.forEach((atCld: any) => {
        if (
          atCld.year === state.modalChild.year &&
          atCld.month === state.modalChild.month &&
          atCld.day === state.modalChild.day
        ) {
          if (state.modalChild.flg === 9) {
            atCld.flg = state.modalChild.flg
            atCld.isNew = ''
            delete atCld.id
          } else {
            Object.keys(state.modalChild).forEach((key: string) => {
              const value = state.modalChild[key]
              atCld[key] = value
            })
            console.log(atCld)

            atCld.isRequest = false

            if ('isNew' in state.modalChild) {
              delete atCld.isNew
              atCld.id = state.modalChild.id
            }
            console.log(atCld)
            console.log(state.modalChild)
          }
        }
      })
  })
  state.atHohouChildAllArray.forEach((el: any, index: number) => {
    if (state.modalChild == null) return
    if (
      el.year === state.modalChild.year &&
      el.month === state.modalChild.month &&
      el.day === state.modalChild.day
    ) {
      if (
        el.cld_id === state.modalChild.cldId ||
        el.cldId === state.modalChild.cldId
      ) {
        if (state.modalChild.flg === 9) {
          state.atHohouChildAllArray.splice(index, 1)
        } else {
          Object.keys(state.modalChild).forEach((key: string) => {
            const value = state.modalChild[key]
            el[key] = value
          })
        }
      }
    }
  })
}

export const handleSortInOrderOfAgeOfVisit = (state: any) => {
  if (state.sortInOrderOfAgeOfVisit) {
    state.sortAgeIdArray = []
    if (state.sortAgeIdArray.length === 0) {
      state.allHohouChildArray = sortInOrderOfSchoolYearOfVisit(
        state.allHohouChildArray
      ) as any

      state.allHohouChildArray.forEach((child: any) => {
        state.sortAgeIdArray.push(child.id)
      })
    }

    const childArray = [] as any
    const atCldArray = [] as any
    state.sortAgeIdArray.forEach((id: string) => {
      state.allHohouChildArray.forEach((child: any) => {
        if (id === child.id) {
          childArray.push(child)
        }
      })
      state.atCldHohouDataArray.forEach((atData: any) => {
        if (id === atData.cldId) {
          atCldArray.push(atData)
        }
      })
    })

    state.allHohouChildArray = childArray
    state.atCldHohouDataArray = atCldArray
  } else {
    const childArray = [] as any
    const atCldArray = [] as any
    state.defaultHohouIdArray.forEach((id: string) => {
      state.allHohouChildArray.forEach((child: { [key: string]: string }) => {
        if (id === child.id) {
          childArray.push(child)
        }
      })
      state.atCldHohouDataArray.forEach((atData: { [key: string]: string }) => {
        if (id === atData.cldId) {
          atCldArray.push(atData)
        }
      })
    })

    state.allHohouChildArray = childArray
    state.atCldHohouDataArray = atCldArray
  }
}

export const handleChangeHolidayOfVisit = (state: any) => {
  state.atCldHohouDataArray.forEach((child: any) => {
    child.data.forEach((atCld: any) => {
      if (
        atCld.year === state.selectYear &&
        atCld.month === state.selectMonth &&
        atCld.day === state.selectCellDay
      ) {
        atCld.flg = 9
        atCld.isNew = ''
        delete atCld.id
        defineObject.VISIT_KEY_DEFAULT_ARRAY.forEach(
          (object: { key: string; value: string | [] }) => {
            atCld[object.key] = object.value
          }
        )
      }
    })
  })

  state.atHohouChildAllArray = state.atHohouChildAllArray.filter(
    (element: { [key: string]: number }) =>
      !(
        element.year === state.selectYear &&
        element.month === state.selectMonth &&
        element.day === state.selectCellDay
      )
  )

  countVisitChildData(state)
}

export const staffMatchHeight = (key: string, className: string) => {
  const cellEleArray = document.getElementsByClassName(className)

  const cellHeightArray: number[] = []

  for (let index = 0; index < cellEleArray.length; index++) {
    cellHeightArray.push(cellEleArray[index].clientHeight)
  }

  const max = cellHeightArray.reduce((a, b) => Math.max(a, b), 0)

  key = max + 'px'

  return key
}

export const ScrollTargetCell = (
  monthNode: any,
  tableNode: any,
  height: number
) => {
  const monthClientLeft = monthNode.getBoundingClientRect().left
  const diffClient = monthClientLeft - height
  tableNode.scrollBy({
    top: 0,
    left: diffClient,
    behavior: 'smooth',
  })
}

export const checkRequest = (dataArray: any, type: string) => {
  let isRequest = false
  dataArray.forEach((data: any) => {
    data.data.forEach((atData: any) => {
      if (!judgementIsPast(atData.year, atData.month, atData.day)) {
        if (type === 'tsusyo') {
          if (atData.flg === 3) {
            isRequest = true
          } else if (atData.flg === 4) {
            isRequest = true
          } else if (atData.flg === 5) {
            isRequest = true
          }
          if (atData.flg === 1 && 'reason_for_reschedule' in atData) {
            const requestType = getKindOfRequest(atData)
            if (requestType === 'reschedule') {
              if (atData.reason_for_reschedule.length !== 0) {
                const reason = atData.reason_for_reschedule.slice(-1)
                if (reason[0].staff === '') {
                  isRequest = true
                }
              }
            }
          }
        } else {
          if (atData.flg === 2) {
            isRequest = true
          }
        }
      }
    })
  })
  return isRequest
}
// 申請スタッフ返信時間
export const insertStaffReplyTimeOfRequest = (
  object: any,
  requestType: string
) => {
  let requestKey
  if (requestType === 'reschedule') {
    requestKey = 'reasonForReschedule'
  }
  if (requestType === 'add') {
    requestKey = 'reasonForAddTo'
  }
  if (requestType === 'absence') {
    requestKey = 'reasonForAbsence'
  }
  if (requestType === 'visitCancel') {
    requestKey = 'visitReasonForAbsence'
  }
  if (!requestKey) return
  const nowTime = getFormatNowTime()
  object[requestKey][object[requestKey].length - 1].staffTime = `${nowTime}`
}

const getFormattedDateAndTimeString = (date: Date) => {
  const year = date.getFullYear()
  const month = ('0' + (date.getMonth() + 1)).slice(-2)
  const day = ('0' + date.getDate()).slice(-2)
  const hours = ('0' + date.getHours()).slice(-2)
  const minutes = ('0' + date.getMinutes()).slice(-2)
  // const seconds = ("0" + date.getSeconds()).slice(-2)

  return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes
}
export const handleFormatDateAndTime = (date: string) => {
  return date
}

export const getTagArray = (allChildArray: ElementType[]) => {
  type ChildItem = { tag: string[] }
  const childArray = allChildArray as ChildItem[]
  const tagMap: Record<string, number> = {}
  childArray.forEach(item => {
    if (!item.tag) return
    item.tag.forEach((tag: string) => {
      tagMap[tag] = (tagMap[tag] || 0) + 1
    })
  })
  // ソート：①出現回数が多い順 ②あいうえお順
  const tagCounts = Object.entries(tagMap)
    .map(([label, count]) => ({ label, count }))
    .sort((a, b) => {
      // ① 出現回数の降順
      if (b.count !== a.count) return b.count - a.count
      // ② 出現回数が同じならあいうえお順
      return a.label.localeCompare(b.label, 'ja')
    })
  return tagCounts
}

// ソート
export const sortInOrderOfAge = (state: StateType) => {
  if (state.sortInOrderOfAge) {
    state.allChildArray = [
      ...sortInOrderOfAgeOfJihatsu(state.allChildArray),
      ...sortInOrderOfSchoolYearOfHoday(state.allChildArray),
    ]
  } else {
    // 名前順で並び替え
    state.allChildArray = formatOrderChildFromJihatsuToHooday(
      state.allChildArray
    )
  }
}

export const sortInOrderOfAgeOfVisit = (state: StateType) => {
  if (state.sortInOrderOfAgeOfVisit) {
    state.allHohouChildArray = [
      ...sortInOrderOfSchoolYearOfVisit(state.allHohouChildArray),
    ]
  } else {
    state.allHohouChildArray = formatOrderChildHohou(state.allHohouChildArray)
  }
}

// 状態のフィルター
export const filterChildDataOfActive = (
  noActiveChildView: boolean,
  allResponseChildArray: ElementType[]
) => {
  return noActiveChildView
    ? [...allResponseChildArray]
    : allResponseChildArray.filter(e => e.active === 1)
}

// タグのフィルター
export const filterChildDataOfTag = (
  selectedFilters: string[],
  allChildArray: ElementType[]
) => {
  return selectedFilters.length === 0
    ? allChildArray
    : allChildArray.filter(
        (child: any) =>
          child.tag &&
          selectedFilters.some((tag: string) => child.tag.includes(tag))
      )
}

export const filterChildData = (state: StateType) => {
  state.allChildArray = filterChildDataOfActive(
    state.noActiveChildView,
    state.allResponseChildArray
  )
  state.allChildArray = filterChildDataOfTag(
    state.selectedFilters,
    state.allChildArray
  )
  sortInOrderOfAge(state)
  sortAttendanceData(state)

  // 通所児童の予定チェック
  state.allChildArray = confirmParentCheckData(
    state.allChildArray,
    state.atChildAllArray
  )
}

export const filterVisitChildData = (state: StateType) => {
  state.allHohouChildArray = filterChildDataOfActive(
    state.noActiveVisitChildView,
    state.allHohouResponseChildArray
  )
  state.allHohouChildArray = filterChildDataOfTag(
    state.visitSelectedFilters,
    state.allHohouChildArray
  )
  sortInOrderOfAgeOfVisit(state)
  sortAttendanceDataOfVisit(state)
}
